export default __webpack_public_path__ + "static/media/t5.9595083d.png";